import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '../components/Icon';
import NavBar from '../components/NavBar';
export default function SystemParticipantNotAllowed({ t }) {
  const authUser = useSelector((state) => state.authorization.user);
  return (
    <div className='km__l--not-allowed'>
      <NavBar user={{ name: authUser.username }} t={t} />
      <div className='km__l--not-allowed-message'>
        <Icon size='70' name='alert-triangle' color='#FF5630' />
        <h2>{t('pages.default.noOrganization')}</h2>
      </div>
    </div>
  );
}
